import * as React from 'react'
import { ReactElement } from 'react'
import { UnitDto } from '../../../../context/GlobalContext'
import { Label } from '@fluentui/react-components'
import { EntityType } from './EntityField'
import { useTranslation } from 'react-i18next'

type Props = {
    unit: UnitDto
    externalType: EntityType
    labelType: EntityLabelType
}

export enum EntityLabelType {
    Multiple = 'MULTIPLE',
    Single = 'SINGLE',
    None = 'NONE',
}

export default function EntityLabel({ unit, externalType, labelType }: Props): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <Label>
            {translate(
                `accounting.dimensions.entity.label.${labelType.toString().toLowerCase().replaceAll(/[-_]/g, '')}.${externalType.toString().toLowerCase().replaceAll(/[-_]/g, '')}`,
                { unit: unit.name, accounting: unit.accounting },
            )}
        </Label>
    )
}
